/* eslint-disable react-hooks/exhaustive-deps */
// React
import { useEffect, useState } from "react";

// Services
import api from "../../services/api";

// Icons
import { 
    IconActiveProfile, 
    IconAdvancePagination, 
    IconBackPagination,  
    IconClose, 
    IconContact, 
    IconSearch 
} from "../icons";

// Components
import ModalDefault from "../ModalDefault";

// Styles
import { 
    Container, 
    ModalContactHead, 
    ModalcontactMain, 
    Paginate, 
    ProfessionalPrices, 
    ProfessionalTitles, 
    SearchHeader 
} from "./styles";

// Libraries
import Select from 'react-select';
import ReactPaginate from 'react-paginate';
import toast, { Toaster } from 'react-hot-toast';
import { Oval } from 'react-loader-spinner';
import { comum } from "../../styles/Themes/light";

interface DataProps {
   uf?: string,
   cidade?: string,
   proposalData?: any,
   proposalType?: any,
   userSelected?: any,
   selected?: any,
   nameUser?: any,
   reuseProfessional?: any,
   reuseProposal?: any,
}

interface UserProps {
    email: string,
    celular: string,
    tel_fixo?: string,
    tel_recado?: string,
}

interface Pagination {
    currentPage: any,
    from: number,
    lastPage: number,
    perPage: number,
    to: number,
    total: number,
}

export default function SearchProfessionalProposal({ 
    uf, 
    cidade, 
    proposalData, 
    proposalType, 
    userSelected, 
    selected, 
    nameUser,
    reuseProfessional,
    reuseProposal
}:DataProps) {
    const [ loading, setLoading ] = useState<any>();
    const [ modalContact, setModalContact ] = useState<any>();
    const [ professionals, setProfessionals ] = useState<any>();
    const [ totalProfiles, setTotalProfiles ] = useState<any>();
    const [ allCounties, setAllCounties ] = useState<any>();
    const [ DTOSearch, setDTOSearch ] = useState<any>('');
    const [ searchProfiles, setSearchProfiles ] = useState<any>('');
    const [ userContacts, setUserContacts ] = useState<UserProps>({
        email: '',
        celular: '',
        tel_fixo: '',
        tel_recado: '',
    });
    // const [ openCounties, setOpenCounties ] = useState<boolean>(false);
    const [ countieSelected, setCountieSelected ] = useState<any>('');
    const [ paginateAllProfiles, setPaginateAllProfiles ] = useState<Pagination>();
    const [ paginateProfiles, setPaginateProfiles ] = useState<Pagination>();
    const [ profit, setProfit ] = useState<any>(0);
    // const [ professionalReuse, setProfessionalReuse ] = useState<any>();

    const city = {
        control: (provided: Record<string, unknown>) => ({
            ...provided,
            height: 40,
            boxShadow: "none",
            cursor: 'pointer',
            border: `1px solid ${comum.colors.interfaceGray400}`,
            '&:hover': {
                border: `1px solid ${comum.colors.interfaceTextGray}`,
            },
        }),
        placeholder: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c353a40)',
            fontSize: '16px',
            fontWeight: '400',
        }),
        singleValue: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c353a40)',
            fontSize: '16px',
        }),
        option: (provided: Record<string, unknown>, state: { isSelected: any; isFocused: boolean }) => ({
            ...provided,
            color: comum.colors.interfaceGray300,
            fontSize: '16px',
            fontWeight: '500',
        }),
    } 

    useEffect(() => {
        
        async function getCounties() {
            try {
                
                setLoading(true);
                const countieArray: { value: any, label: any }[] = []

                const response = await api.get('comarca')
                // setAllCounties(response.data.result)                

                if (response.data.status !== 'success') {
                    throw new Error()
                }

                countieArray.push({
                    label:'Todas as Comarcas',
                    value: 'TodasTodas'
                })

                response.data.result.map((row: any) => (
                    countieArray.push({
                        label: `${row.uf} - ${row.cidade}`,
                        value: `${row.uf} - ${row.cidade}`,
                    })
                ))

                setAllCounties(countieArray);

                setLoading(false);

            } catch (err) {

                console.log('log do erro pegando comarcas', err);

                setLoading(false);

            }
            
        }
        
        // Limpa os campos de busca toda vez que o componente for iniciado
        setDTOSearch('');
        setSearchProfiles('');
        
        getCounties();
        getProfessionals(cidade, 1);

        // async function getProfessionalById(id: any) {
        //     try {
                
        //         setLoading(true);

        //         const response = await api.get('usuario/' + id)
        //         setProfessionalReuse(response.data.result)
                
        //         if (response.data.status !== 'success') {

        //             if (response.data.result[0] === undefined) {
        //                 throw new Error(response.data.message);

        //             } else {
        //                 throw new Error(response.data.result[0].message);
        //             }

        //         }
        //         setLoading(false);

        //     } catch (error: any) {  
        //         console.log('log do response error', error);
        //         setLoading(false);
        //         toast.error(error.message, {
        //             duration: 3000,
        //             className: 'toasted',
        //             style: {
        //                 padding: '16px',
        //                 color: 'var(--c1a2858)',
        //             },
        //             iconTheme: {
        //                 primary: 'var(--cf24343)',
        //                 secondary: 'var(--cfffaee)',
        //             },
        //         });
        //     }
            
        // }

        // getProfessionalById(reuseProfessional);
        
    }, [cidade])

    useEffect(() => {        
        
        
        // Sempre executa a busca quando searchProfiles mudar
        if (searchProfiles !== undefined) {
            if (countieSelected === 'Todas') {
                getAllProfessionals(1, searchProfiles)
            } else {
                // Usa a cidade selecionada se disponível, senão usa a cidade padrão
                const selectedCity = countieSelected || cidade;
                getProfessionals(selectedCity, 1, searchProfiles);
            }
        }
    }, [searchProfiles, countieSelected, cidade])

    // Profissionais que vão aparecer em todas as comarcas
    const selectedPros = [
        3513,
        3586,
        3588,
        3633,
        3591,
        3592,
        3593,
        3594,
        3595,
        3596,
        3597,
        3598,
        3618,
        3619,
        3620,
        3621,
        3622,
        3669,
        3699,
        3700
    ]

    const extractCityFromCounty = (value?: string) => {
        if (!value || value === 'Todas' || value === 'TodasTodas') {
            return ''
        }

        const separatorIndex = value.indexOf(' - ')
        return separatorIndex >= 0 ? value.slice(separatorIndex + 3).trim() : value.trim()
    }

    const buildQueryParams = (query?: { page?: number; nome?: string; includeGeneral?: boolean }) => {
        const params = new URLSearchParams()
        params.set('page', String(query?.page ?? 1))
        params.set('limit', '10')
        params.set('nome', query?.nome ?? '')
        params.set('status', 'ativo')
        params.set('ordem', 'usuario.nome')
        params.set('tipo_ordem', 'asc')
        if (query?.includeGeneral) {
            params.set('profissionais_gerais', selectedPros.join(','))
        }
        return params
    }

    
    async function getProfessionals(city: any, page: number, searchTerm?: string) {
        let idCategory: number = 0;
        
        try {
            // Usa o searchTerm passado como parâmetro ou fallback para searchProfiles
            const termToSearch = searchTerm !== undefined ? searchTerm : (searchProfiles || '');
            
            if (city === undefined) {
                city = ''
            }

            if (proposalType === 'Audiência') {

                proposalType = 'Audiencia'
                idCategory = 1;

            } else if (proposalType === 'Diligencia' || proposalType === 'Diligência') {

                proposalType = 'Diligencia'
                idCategory = 2;

            } else if (proposalType === 'Protocolo') {
                
                idCategory = 3;
                
            } else if (proposalType === 'Outros') {
                
                idCategory = 4
                
            }

            if (city === 'Todas') {
                setProfit(100);

                setLoading(true);
                
                const params = buildQueryParams({ page, nome: termToSearch, includeGeneral: true })
                const response = await api.get(`usuario?${params.toString()}`)

                setProfessionals(response.data.result.data);
                setTotalProfiles(response.data.result.pagination.total);
                setPaginateAllProfiles(response.data.result.pagination);

                if (response.data.status !== 'success') {
                    throw new Error()
                }

                setLoading(false);
                
            } else {
                
                setLoading(true);
    
                const params = buildQueryParams({ page, nome: termToSearch })
                const normalizedCounty = extractCityFromCounty(city)
                if (normalizedCounty) {
                    params.set('comarca', normalizedCounty)
                }
                params.set('categoria_servico', proposalType)
                params.set('id_categoria_de_servico', String(idCategory))
                params.set('profissional_necessario', proposalData.profissional_necessario)
                params.set('id_comarca', String(proposalData.id_comarca))
                params.set('valor_cliente', String(proposalData.valor_cliente))
                params.set('id_servico', String(proposalData.id_servico))

                const response = await api.get(`usuario-com-valores/?${params.toString()}`)
    
                setProfessionals(response.data.result.data);
                setTotalProfiles(response.data.result.pagination.total);
                setPaginateProfiles(response.data.result.pagination);
                
                if (response.data.status !== 'success') {
                    throw new Error()
                }

                setLoading(false);
            }


            setLoading(false);

        } catch (err: any) {

            console.log('log do erro pegando profissionais para comarca', err);

            setLoading(false);

        }
    }

    async function getAllProfessionals(page: any, searchTerm?: string) {
        
        try {

            setLoading(true);
            
            const termToSearch = searchTerm !== undefined ? searchTerm : (searchProfiles || '');
            const params = buildQueryParams({ page, nome: termToSearch, includeGeneral: true })
            const response = await api.get(`usuario?${params.toString()}`)
            
            setProfessionals(response.data.result.data);
            setTotalProfiles(response.data.result.pagination.total);
            setPaginateAllProfiles(response.data.result.pagination);            

            if (response.data.status !== 'success') {
                throw new Error()
            }

            setLoading(false);

        } catch (err: any) {

            console.log('log do erro pegando profissionais para comarca', err);

            setLoading(false);

        }
    }

    function searchKeyPressed(event: any) {

        if (event.key === 'Enter') {
            // Atualiza o estado de busca E executa a busca imediatamente
            setSearchProfiles(DTOSearch);
            
            // Executa a busca imediatamente para garantir que funcione
            if (countieSelected === 'Todas') {
                getAllProfessionals(1, DTOSearch);
            } else {
                const selectedCity = countieSelected || cidade;
                getProfessionals(selectedCity, 1, DTOSearch);
            }
        }

    }

    function clearSearch() {
        setDTOSearch('')
        setSearchProfiles('')
        setTotalProfiles('')
    }

    // useEffect(() => {
    //     // calculatePercentage()

    //     console.log('log do tipo de categoria de serviço', proposalType)

    //     // console.log('log da proposal', proposalData)
    // }, [proposalData, userSelected, professionals])


    // function calculatePercentage() {
       
    //     if (countieSelected !== 'Todas') {
            
    //         // console.log('log professionals inside calculate percent', professionals)
           
    //        if (professionals) {

    //             const total = proposalData.valor_cliente;
    //             const partial: any = [];          
    
    //             professionals.map((row: any, key: any) => (
    //                 partial.push({
        //                     id: key,
    //                     value: ((100 * row.lucro) / total).toFixed()
    //                 })
    //             ))
                    
                
    //            setProfit(partial)
    //         //    console.log('log do partial array', partial)           
    //         }
    
    //     } 

    // }

    return (
        <Container>

            {
                loading &&
                <Oval
                    height={150}
                    width={150}
                    color={comum.colors.primaryRed400}
                    wrapperStyle={{}}
                    wrapperClass="loader"
                    visible={true}
                    ariaLabel='oval-loading'
                    secondaryColor={comum.colors.primaryRed400}
                    strokeWidth={2}
                    strokeWidthSecondary={2}
                />
            }

            {
                !loading &&
                <>
                    <SearchHeader>
                        <div className="search">
                            <div
                                className="buscar"
                                onClick={() => {
                                    setSearchProfiles(DTOSearch);
                                    
                                    // Executa a busca imediatamente
                                    if (countieSelected === 'Todas') {
                                        getAllProfessionals(1, DTOSearch);
                                    } else {
                                        const selectedCity = countieSelected || cidade;
                                        getProfessionals(selectedCity, 1, DTOSearch);
                                    }
                                }}
                            >
                                <IconSearch />
                            </div>
                            <input
                                placeholder="Pesquisar"
                                onChange={(e) => setDTOSearch(e.target.value)}
                                onKeyDown={(e) => searchKeyPressed(e)}
                                value={DTOSearch}
                            />
                            {
                                DTOSearch &&
                                <div
                                    className="clean-search"
                                    onClick={() => clearSearch()}
                                >
                                    <IconClose />
                                </div>
                            }
                        </div>

                        <div className="countie-status">
                            <span>{totalProfiles} resultados para:</span>
                            <div className="select">
                                <Select
                                    styles={city}
                                    components={{
                                        IndicatorSeparator: () => null
                                    }}
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 8,
                                        colors: {
                                            ...theme.colors,
                                            primary25: comum.colors.interfacePure100,
                                            primary50: comum.colors.interfacePure100,
                                            primary: comum.colors.interfacePure100,
                                        },
                                    })}
                                    name='id_comarca'
                                    placeholder="Selecionar"
                                    options={allCounties}
                                    value={
                                        countieSelected === 'Todas'
                                            ? { value: 'TodasTodas', label: 'Todas as Comarcas' }
                                            : countieSelected 
                                                ? { value: `${uf} - ${countieSelected}`, label: `${uf} - ${countieSelected}` }
                                                : uf && cidade 
                                                    ? { value: `${uf} - ${cidade}`, label: `${uf} - ${cidade}` }
                                                    : null
                                    }
                                    onChange={(e: any) => { 
                                        if (e.value === 'TodasTodas') {
                                            setCountieSelected('Todas');
                                            getAllProfessionals(1, searchProfiles);
                                        } else {
                                            setCountieSelected(e.value.slice(5)); 
                                            getProfessionals(e.value.slice(5), 1, searchProfiles);
                                        }
                                    }}
                                />  
                            </div>
                        </div>
                    </SearchHeader>

                    <ProfessionalTitles>
                        <div className="icon-profile"></div>
                        <div className="name">Nome</div>
                        <div className="service">Serviço</div>
                        <div className="profit">Lucro</div>
                        <div className="code">Código</div>
                        <div className="contact"></div>
                    </ProfessionalTitles>
                </>
            }

            {   !loading &&
                professionals &&
                professionals?.map((row: any, key: any) => (
                    <ProfessionalPrices 
                        key={row.id_usuario}
                        onClick={() => { userSelected('id_usuario', row.id_usuario); nameUser(row.nome); }}
                        selected={selected === row.id_usuario}
                    >
                        <div className="icon-profile"><IconActiveProfile color={comum.colors.primaryRed400}/></div>
                        <div className="name">{row.nome}</div>

                        {
                            row.valor_profissional === undefined &&
                            <div className="service">R$ 0,00</div>
                        }

                        {
                            row.valor_profissional !== undefined &&
                            <div className="service">R$ {row.valor_profissional},00</div>
                        }
                        
                        {   
                            !row.lucro_porcentagem || row.lucro_porcentagem === null 
                            ?                            
                                <div 
                                    className={"profit"}
                                >
                                    {`${profit}%`}
                                </div>    
                            :   ''
                        }
                        {   
                            row.lucro_porcentagem &&
                            row.lucro_porcentagem !== null &&                            
                            <div 
                                className={row.lucro_porcentagem >= 0 ? "profit" : "profit negative" }                                
                            >
                                {row.lucro_porcentagem?.toFixed()}%
                            </div>
                            
                        }
                        
                        <div className="code">D{row.id_usuario}</div>
                        <div 
                            className="contact"
                            onClick={() => {
                                setModalContact(true); setUserContacts({
                                    email: row.email, 
                                    celular: row.celular.replace(/\D/g, '')
                                        .replace(/(\d{2})(\d)/, '($1) $2')
                                        .replace(/(\d{5})(\d)/, '$1-$2')
                                        .replace(/(-\d{4})\d+?$/, '$1'), 
                                    tel_fixo: row.tel_fixo.replace(/\D/g, '')
                                        .replace(/(\d{2})(\d)/, '($1) $2')
                                        .replace(/(\d{4})(\d)/, '$1-$2')
                                        .replace(/(-\d{4})\d+?$/, '$1'), 
                                    tel_recado: row.tel_recado.replace(/\D/g, '')
                                        .replace(/(\d{2})(\d)/, '($1) $2')
                                        .replace(/(\d{4})(\d)/, '$1-$2')
                                        .replace(/(-\d{4})\d+?$/, '$1') 
                            }) }}
                        >
                            <IconContact color={comum.colors.primaryRed400}/>
                        </div>
                    </ProfessionalPrices>                    
                ))
            }

            {/* {
                reuseProposal &&
                <ProfessionalPrices
                    onClick={() => { userSelected('id_usuario', professionalReuse?.id_usuario); nameUser(professionalReuse?.nome) }}
                    selected={selected === professionalReuse?.id_usuario}
                >
                    <div className="icon-profile"><IconActiveProfile /></div>
                    <div className="name">{professionalReuse?.nome}</div>
                    <div className="service">R$ {professionalReuse?.valor_profissional},00</div>
                    <div
                        className={professionalReuse?.lucro >= 0 ? "profit" : "profit negative"}
                    >
                        R$ {professionalReuse?.lucro},00
                    </div>
                    <div className="code">{professionalReuse?.id_usuario}</div>
                    <div
                        className="contact"
                        onClick={() => {
                            setModalContact(true); setUserContacts({
                                email: professionalReuse?.email,
                                celular: professionalReuse?.celular.replace(/\D/g, '')
                                    .replace(/(\d{2})(\d)/, '($1) $2')
                                    .replace(/(\d{5})(\d)/, '$1-$2')
                                    .replace(/(-\d{4})\d+?$/, '$1'),
                                tel_fixo: professionalReuse?.tel_fixo.replace(/\D/g, '')
                                    .replace(/(\d{2})(\d)/, '($1) $2')
                                    .replace(/(\d{5})(\d)/, '$1-$2')
                                    .replace(/(-\d{4})\d+?$/, '$1'),
                                tel_recado: professionalReuse?.tel_recado.replace(/\D/g, '')
                                    .replace(/(\d{2})(\d)/, '($1) $2')
                                    .replace(/(\d{5})(\d)/, '$1-$2')
                                    .replace(/(-\d{4})\d+?$/, '$1')
                            })
                        }}
                    >
                        <IconContact />
                    </div>
                </ProfessionalPrices>      
            } */}

            {
                countieSelected === 'Todas' && 
                paginateAllProfiles &&
                !loading &&
                <Paginate>
                    <ReactPaginate
                        breakLabel="..."
                        nextLabel={<IconAdvancePagination />}
                        previousLabel={<IconBackPagination />}
                        onPageChange={(value) => getAllProfessionals(value.selected)}
                        pageRangeDisplayed={1}
                        marginPagesDisplayed={1}
                        pageCount={paginateAllProfiles?.lastPage}
                        forcePage={paginateAllProfiles.currentPage !== undefined ? paginateAllProfiles.currentPage - 1 : 0}
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="back-page"
                        previousLinkClassName="back-link-page"
                        nextClassName="next-page"
                        nextLinkClassName="next-link-page"
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        containerClassName="pagination"
                        activeClassName="active"
                        activeLinkClassName="active"
                    />
                </Paginate>
            }
            {
                countieSelected !== 'Todas' &&
                paginateProfiles &&
                !loading &&
                < Paginate >
                    <ReactPaginate
                        breakLabel="..."
                        nextLabel={<IconAdvancePagination />}
                        previousLabel={<IconBackPagination />}
                        onPageChange={(value) => getProfessionals(cidade, value.selected+1)}
                        pageRangeDisplayed={1}
                        marginPagesDisplayed={1}
                        pageCount={paginateProfiles.lastPage}
                        forcePage={paginateProfiles.currentPage !== undefined ? paginateProfiles.currentPage - 1 : 0}
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="back-page"
                        previousLinkClassName="back-link-page"
                        nextClassName="next-page"
                        nextLinkClassName="next-link-page"
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        containerClassName="pagination"
                        activeClassName="active"
                        activeLinkClassName="active"
                    />
                </Paginate>
            }

            <ModalDefault
                id={'overlayModal'}
                onClose={() => setModalContact((modalContact: any) => !modalContact)}
                openModal={modalContact}
                width="fit-content"
            >
                <ModalContactHead>
                    <div>
                        Entre em contato
                    </div>

                    <div
                        className="close"
                        onClick={() => setModalContact(false)}
                    >
                        <IconClose />
                    </div>
                </ModalContactHead>

                
                <ModalcontactMain>
                    <div>{userContacts.email}</div>
                    <div>{userContacts.celular}</div>
                    <div>{userContacts.tel_fixo ? userContacts.tel_fixo : 'sem telefone fixo'}</div>
                    <div>{userContacts.tel_recado ? userContacts.tel_recado : 'sem telefone de recado'}</div>
                </ModalcontactMain>
            </ModalDefault> 

        </Container>
    )
}